import { useState } from "react";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = fd.get("phone_alt")?.toString().trim() ?? "";
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，感谢关注吃瓜精选热门榜！");
      form.reset();
      return;
    }

    const email = fd.get("email")?.toString().trim() ?? "";
    if (!email) {
      setStatus("error");
      setMessage("请填写有效的邮箱地址。");
      return;
    }

    const payload = new URLSearchParams();
    payload.set("email", email);

    try {
      setStatus("idle");
      const response = await fetch("https://readdy.ai/api/form/dafapq3ep053ijub1mrg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = responseText ? JSON.parse(responseText) : {};
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || "";
      if (!response.ok || parsed?.code !== "OK") {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后重试。");
        return;
      }
      setStatus("success");
      setMessage(serverMsg || "订阅成功，感谢关注吃瓜精选热门榜！");
      form.reset();
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  };

  return (
    <section className="bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3.5 py-1.5 text-xs font-medium text-background-100 ring-1 ring-background-50/20">
            <i className="ri-mail-send-line text-accent-400"></i>
            每日更新 · 不错过任何爆款
          </span>
          <h2 className="mt-5 font-display text-3xl md:text-4xl text-background-50">
            订阅吃瓜精选，每天直通<span className="text-accent-400">热度TOP</span>
          </h2>
          <p className="mt-4 max-w-xl mx-auto text-sm md:text-base text-background-100/80 leading-relaxed">
            留下邮箱，吃瓜精选热门榜与本周排行的焦点事件将第一时间推送到你身边，省去翻找时间。
          </p>
        </div>

        {status === "success" ? (
          <div className="mx-auto mt-8 flex max-w-lg items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50">
            <i className="ri-checkbox-circle-fill"></i>
            {message}
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form className="mx-auto mt-8 flex max-w-lg flex-col gap-3 sm:flex-row">
            <label className="sr-only" htmlFor="sub-email">邮箱地址</label>
            <input
              id="sub-email"
              name="email"
              type="email"
              required
              autoComplete="email"
              placeholder="输入你的邮箱地址"
              className="h-12 flex-1 rounded-full border border-background-700 bg-background-800/60 px-5 text-sm text-background-50 placeholder:text-background-500 focus:outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-400/30 transition"
            />
            {/* honeypot */}
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="hp-field"
            />
            <button
              type="submit"
              className="whitespace-nowrap inline-flex items-center justify-center gap-1.5 h-12 px-7 rounded-full bg-accent-500 text-background-950 text-sm font-bold hover:bg-accent-400 transition-colors"
            >
              立即订阅
              <i className="ri-send-plane-fill"></i>
            </button>
          </form>
        )}

        {status === "error" && (
          <p className="mt-3 text-center text-sm text-secondary-300">
            <i className="ri-error-warning-line mr-1"></i>
            {message}
          </p>
        )}

        <p className="mt-5 text-center text-xs text-background-500">
          订阅后可随时退订 · 你的信息仅用于发送吃瓜精选更新
        </p>
      </div>
    </section>
  );
}